import Column from '@components/Column';

import ArrowUpIcon from './ArrowUpIcon';
import styles from './styles.module.scss';

interface Props {
    moveNext: () =>void;
    movePrev: () =>void;
}

function Remote({ movePrev, moveNext }:Props) {
    return (
        <Column className={styles.container}
            spacing={8} >
            <ArrowUpIcon onClick={movePrev}/>
            <ArrowUpIcon onClick={moveNext}/>
        </Column>
    );
}

export default Remote;
